import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Typography, Button, Stack, useMediaQuery, useTheme, SvgIcon } from "@mui/material";
import TextsmsIcon from "@mui/icons-material/Textsms";
import MedicalInformationIcon from "@mui/icons-material/MedicalInformation";
import EventIcon from "@mui/icons-material/Event";
import { useNavigate } from "react-router-dom";
import { ReactComponent as CasesSvg } from "../../assets/icons/health_metrics.svg";

import Question from "../../components/Question";
import InfoCard from "../../components/InfoCard";
import { handleContactCareTeam } from "../../lib/utils";
import { reset as userReset } from "../../redux/userSlice";
import { reset as insuranceReset } from "../../redux/insuranceSlice";
import { reset as stripeReset } from "../../redux/stripeSlice";

const HealthMetrics = React.forwardRef(function HealthMetricsIcon(props, ref) {
  return <SvgIcon component={CasesSvg} inheritViewBox ref={ref} {...props} />;
});

export default function CaseIsotretinoinThankYou(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));

  useEffect(() => {
    dispatch(userReset());
    dispatch(insuranceReset());
    dispatch(stripeReset());
  }, [dispatch]);

  const primaryBtnSx = {
    width: isDesktop ? "50%" : "100%",
    borderColor: "piction.highlight",
    backgroundColor: "piction.highlight",
    color: "white",
    borderRadius: "20px",
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    px: 2.5,
    "&:hover, &:active, &:focus": {
      backgroundColor: "piction.highlight",
      borderColor: "piction.highlight",
      color: "white",
      boxShadow: "none",
    },
  };

  return (
    <Question
      noBack={true}
      backgroundColor="#82B1FF33"
      componentHeight="100vh"
      title="Thank you!"
      input={
        <>
          <Typography variant="body1" mt={1} mb={2}>
            Your information has been securely submitted.
          </Typography>

          <Typography variant="h6" fontWeight={400} mt={2} mb={1}>
            What to expect next
          </Typography>

          <InfoCard
            icon={EventIcon}
            title="Clinician visit (30 minutes)"
            description="Next, you'll have a 30-minute video visit with one of our clinicians to review your medical history, confirm whether isotretinoin (Accutane) is a safe option for you and answer any questions."
          />

          <InfoCard
            icon={MedicalInformationIcon}
            title="Dermatologist review"
            description="After your visit, a board-certified dermatologist will review your information and develop your personalized treatment plan."
          />

          <Stack
            direction="column"
            spacing={2}
            mt={2}
            sx={{ width: "100%", alignItems: "center" }}
          >
            <Button
              fullWidth
              variant="outlined"
              startIcon={<TextsmsIcon />}
              onClick={handleContactCareTeam}
              sx={primaryBtnSx}
            >
              Text us
            </Button>

            <Button
              fullWidth
              variant="outlined"
              startIcon={<HealthMetrics sx={{ color: "white" }} />}
              onClick={() => navigate("/case-list", { state: { portal: true } })}
              sx={primaryBtnSx}
            >
              Visit Patient Portal
            </Button>
          </Stack>
        </>
      }
      {...props}
    />
  );
}
